module.exports = __webpack_public_path__ + "static/img/circle.0e7e5240.svg";